"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChart = void 0;
const react_1 = __importStar(require("react"));
const group_1 = require("@visx/group");
const axis_1 = require("@visx/axis");
const scale_1 = require("@visx/scale");
const event_1 = require("@visx/event");
const styled_components_1 = require("styled-components");
const variants_1 = require("./../../themes/variants");
const polished_1 = require("polished");
const main_1 = require("../useTooltip/main");
const shape_1 = require("@visx/shape");
const list_1 = require("../useTooltip/list");
const BarChart = ({ width, height, margin = { top: 30, right: 30, bottom: 60, left: 60 }, xLabel, yLabel, data, variant, colors, onChange, selectedLabel, tooltipAxis = true, tooltip = true, }) => {
    const theme = (0, styled_components_1.useTheme)();
    const chartTooltip = (0, main_1.useTooltip)();
    const [coordsLine, setCoordsLine] = (0, react_1.useState)();
    if (data === undefined || data.length === 0 || width < 10) {
        return null;
    }
    const primaryColor = (0, variants_1.variantTextColor)({ theme, variant });
    const bgColor = (0, variants_1.variantBgColor)({ theme, variant });
    colors =
        colors ||
            (() => {
                const maxDiff = 0.3;
                const step = maxDiff / data.length;
                const colors = [];
                const start = (0, polished_1.lighten)(maxDiff / 2, primaryColor);
                let dark = 0;
                while (colors.length < data.length) {
                    colors.push((0, polished_1.darken)(dark, start));
                    dark = dark + step;
                }
                return colors;
            })();
    const xMax = width - margin.left - margin.right;
    const yMax = height - margin.top - margin.bottom;
    const { labels, keys } = (() => {
        const { labels, keys } = data.reduce((prev, curr) => {
            prev.keys.push(curr.serie);
            Object.assign(prev.labels, curr.values);
            return prev;
        }, {
            labels: {},
            keys: [],
        });
        return { labels: Object.keys(labels), keys };
    })();
    const keysScale = (0, scale_1.scaleBand)({
        domain: keys,
        range: [0, xMax],
        round: true,
        padding: 0.1,
    });
    const labelsScale = (0, scale_1.scaleBand)({
        domain: labels,
        range: [0, keysScale.bandwidth()],
        round: true,
        padding: 0.1,
    });
    const rectWidth = labelsScale.bandwidth();
    const valuesDOmain = data.reduce((prev, curr) => {
        prev[0] = Math.min(prev[0], ...labels.map((key) => curr.values[key]));
        prev[1] = Math.max(prev[1], ...labels.map((key) => curr.values[key]));
        return prev;
    }, [0, 0]);
    const valuesScale = (0, scale_1.scaleLinear)({
        domain: valuesDOmain,
        range: [yMax, 0],
    });
    const colorScale = (0, scale_1.scaleOrdinal)({
        domain: labels,
        range: colors,
    });
    function showTooltip(item, event, selectedLabel) {
        const eventSvgCoords = (0, event_1.localPoint)(event);
        const { values, serie } = item;
        const keys = Object.keys(values);
        const title = selectedLabel || serie;
        const tooltipValues = selectedLabel
            ? data.map((item) => {
                return {
                    label: item.serie,
                    value: item.values[selectedLabel],
                    color: colorScale(selectedLabel),
                };
            })
            : keys.map((key) => {
                return {
                    label: key,
                    value: values[key],
                    color: colorScale(key),
                };
            });
        values &&
            chartTooltip.show({
                left: (eventSvgCoords === null || eventSvgCoords === void 0 ? void 0 : eventSvgCoords.x) || 0,
                top: (eventSvgCoords === null || eventSvgCoords === void 0 ? void 0 : eventSvgCoords.y) || 0,
                title: title,
                values: tooltipValues,
                renderer: typeof tooltipAxis === "function"
                    ? tooltipAxis
                    : tooltipAxis
                        ? list_1.ChartTooltipList
                        : tooltip,
            });
    }
    const containerSize = {
        width,
        height,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", Object.assign({}, containerSize),
            react_1.default.createElement("rect", Object.assign({}, containerSize, { rx: 14, fill: bgColor })),
            react_1.default.createElement(axis_1.AxisLeft, { scale: valuesScale, stroke: primaryColor, tickStroke: primaryColor, left: margin.left, top: margin.top, tickLabelProps: () => ({
                    fill: primaryColor,
                    fontSize: 11,
                    textAnchor: "end",
                }), label: yLabel, labelProps: {
                    x: -(yMax / 2),
                    y: -40,
                    textAnchor: "middle",
                    fontSize: 14,
                    fontWeight: 800,
                    fill: primaryColor,
                } }),
            react_1.default.createElement(axis_1.AxisBottom, { top: yMax + margin.top, left: margin.left, scale: keysScale, stroke: primaryColor, tickStroke: primaryColor, label: xLabel, labelProps: {
                    x: xMax / 2,
                    y: 40,
                    textAnchor: "middle",
                    fontSize: 14,
                    fontWeight: 800,
                    fill: primaryColor,
                }, tickLabelProps: () => ({
                    fill: primaryColor,
                    fontSize: 11,
                    textAnchor: "middle",
                }) }),
            react_1.default.createElement(group_1.Group, { top: margin.top, left: margin.left }, data.map((item, i) => {
                const groupX = keysScale(item.serie) || 0;
                return (react_1.default.createElement(group_1.Group, { key: `group-${i}`, onMouseLeave: () => {
                        !selectedLabel && chartTooltip.hide();
                    }, onMouseMove: (event) => {
                        showTooltip(item, event, selectedLabel);
                    } },
                    react_1.default.createElement("rect", { key: `rect-${i}`, x: groupX, y: 0, width: keysScale.bandwidth(), height: yMax, fill: "transparent" }),
                    labels.map((label, j) => {
                        let fillColor = colorScale(label);
                        if (selectedLabel && selectedLabel !== label)
                            fillColor = (0, polished_1.rgba)(fillColor, 0.5);
                        const value = item.values[label];
                        const rectX = labelsScale(label) || 0;
                        const x = groupX + rectX;
                        const y = valuesScale(value);
                        const rectHeight = yMax - y;
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("rect", { key: `rect-${i}-${j}`, x: groupX + rectX, y: y, width: rectWidth, height: rectHeight, fill: fillColor }),
                            react_1.default.createElement("rect", { key: `rect-bg-${i}-${j}`, x: groupX + rectX, y: 0, width: rectWidth, height: yMax, fill: "transparent", cursor: "pointer", onMouseLeave: () => setCoordsLine(undefined), onMouseMove: () => setCoordsLine([x + rectWidth / 2, y]), onClick: (event) => {
                                    selectedLabel === label
                                        ? chartTooltip.hide()
                                        : showTooltip(item, event, label);
                                    onChange &&
                                        onChange(selectedLabel !== label
                                            ? {
                                                point: item,
                                                key: label,
                                                value,
                                            }
                                            : undefined);
                                } })));
                    })));
            })),
            coordsLine && (react_1.default.createElement("g", null,
                react_1.default.createElement(shape_1.Line, { from: {
                        x: coordsLine[0] + margin.left,
                        y: margin.top,
                    }, to: {
                        x: coordsLine[0] + margin.left,
                        y: height - margin.bottom + 5,
                    }, stroke: primaryColor, strokeWidth: 1, pointerEvents: "none", strokeDasharray: "5,2" }),
                react_1.default.createElement(shape_1.Line, { from: {
                        x: margin.left - 5,
                        y: coordsLine[1] + margin.top,
                    }, to: {
                        x: width - margin.right,
                        y: coordsLine[1] + margin.top,
                    }, stroke: primaryColor, strokeWidth: 1, pointerEvents: "none", strokeDasharray: "5,2" }),
                react_1.default.createElement("circle", { cx: coordsLine[0] + margin.left, cy: coordsLine[1] + margin.top, r: 4, fill: bgColor, stroke: primaryColor, strokeWidth: 2 })))),
        chartTooltip.element));
};
exports.BarChart = BarChart;
//# sourceMappingURL=main.js.map